import {
	createContext,
	type Dispatch,
	type SetStateAction,
	useContext,
} from "react";

/**
 * Phase 37 — Lifted save state from the form bodies up to AddEventSheet's header.
 *
 * Each form (Appointment/Test, Medication, Cycle, Admin) registers its current
 * isValid / isPending / save handler via `setFormState`. AddEventSheet reads from
 * `formState` to render the type-coloured Save button on the right side of the
 * sheet header. This replaces the sticky bottom Save/Cancel footer.
 *
 * `formState` is null when no form is mounted (chooser step).
 */
export interface FormHeaderState {
	isValid: boolean;
	isPending: boolean;
	mode: "create" | "edit";
	onSave: () => void;
}

interface FormHeaderContextValue {
	formState: FormHeaderState | null;
	setFormState: Dispatch<SetStateAction<FormHeaderState | null>>;
}

export const FormHeaderContext = createContext<FormHeaderContextValue | null>(
	null,
);

export function useFormHeader(): FormHeaderContextValue {
	const ctx = useContext(FormHeaderContext);
	if (!ctx) {
		throw new Error(
			"useFormHeader must be used within FormHeaderContext.Provider — wrap form bodies in AddEventSheet",
		);
	}
	return ctx;
}
